import { createSlice } from '@reduxjs/toolkit';
import { IProfile, IStudent } from '~/utils/interface/profile';
import { getProfile, getStudents, updateProfile } from './userThunk';
import { RootState } from '~/utils/redux/store';

interface userState {
  profile: IProfile | null;
  isRefresh: boolean;
  students: IStudent[];
}

const initialState: userState = {
  profile: null,
  isRefresh: false,
  students: [],
};

const userSlice = createSlice({
  name: 'userSlice',
  initialState,
  reducers: {
    setRefresh(state, action) {
      state.isRefresh = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProfile.pending, (state) => {})
      .addCase(getProfile.fulfilled, (state, action) => {
        state.profile = action.payload.data;
      })
      .addCase(getProfile.rejected, (state, action) => {});

    // Update profile
    builder
      .addCase(updateProfile.pending, (state) => {})
      .addCase(updateProfile.fulfilled, (state, action) => {})
      .addCase(updateProfile.rejected, (state, action) => {});

    // Get students
    builder
      .addCase(getStudents.pending, (state) => {})
      .addCase(getStudents.fulfilled, (state, action) => {
        state.students = action.payload.data;
      })
      .addCase(getStudents.rejected, (state, action) => {});
  },
});

// Actions
export const userActions = userSlice.actions;

// Selectors
export const selectIsRefresh = (state: RootState) => state.userState.isRefresh;
export const selectStudents = (state: RootState) => state.userState.students;

// Reducer
const userReducer = userSlice.reducer;
export default userReducer;
